import React, { useEffect, useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
import { useLanguage } from '../context/LanguageContext';
const AnimatedText: React.FC<{
  text: string;
}> = ({
  text
}) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(v => !v);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  const letters = text.split('');
  return <span className="inline-flex overflow-hidden" data-id="element-85">
      <AnimatePresence mode="wait" data-id="element-86">
        {visible && <motion.span key="text" className="inline-flex" initial="hidden" animate="visible" exit="exit" variants={{
        visible: {
          transition: {
            staggerChildren: 0.04
          }
        },
        exit: {
          transition: {
            staggerChildren: 0.03,
            staggerDirection: -1
          }
        }
      }} data-id="element-87">
            {letters.map((letter, i) => <motion.span key={i} className={letter === ' ' ? 'inline-block w-1.5' : 'inline-block'} variants={{
          hidden: {
            opacity: 0,
            y: 12
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.3
            }
          },
          exit: {
            opacity: 0,
            y: -12,
            transition: {
              duration: 0.25
            }
          }
        }} data-id="element-88">
                {letter}
              </motion.span>)}
          </motion.span>}
      </AnimatePresence>
    </span>;
};
export const Hero: React.FC = () => {
  const {
    t
  } = useLanguage();
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-beige-50" data-id="element-89">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-90">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-coral-400/10 rounded-full blur-3xl" data-id="element-91"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 bg-beige-200/40 rounded-full blur-3xl" data-id="element-92"></div>
      </div>

      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-94">
          <span className="inline-flex items-center py-1 px-3 rounded-full bg-red-500/10 text-red-600 font-sans font-medium text-sm mb-6 tracking-wide uppercase h-8" data-id="element-95">
            <AnimatedText text={t('hero.badge')} data-id="element-96" />
          </span>

          <motion.h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-dark" animate={{
          x: [0, -4, 4, -3, 3, -2, 2, 0],
          rotate: [0, -0.5, 0.5, -0.3, 0.3, 0]
        }} transition={{
          duration: 0.5,
          repeat: Infinity,
          repeatDelay: 3,
          ease: 'easeInOut'
        }} data-id="element-97">
            {t('hero.title.1')}{' '}
            <span className="text-coral-500 italic" data-id="element-98">UGC</span>{' '}
            {t('hero.title.2')}
          </motion.h1>

          <p className="text-xl md:text-2xl text-gray-600 font-sans font-light mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-99">
            {t('hero.subtitle')}
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-100">
            <Button className="w-full sm:w-auto text-lg px-10 py-5" onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-101">
              {t('hero.btn')}
            </Button>
            <p className="mt-4 text-sm text-gray-500 font-sans" data-id="element-102">
              {t('hero.guarantee')}
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};